import { ITrackingProduct } from '../../types/tracking';

interface IExtra {
  house_id?: string;
  document_url?: string;
}

export const getTrackingProducts = (builderId: number, extra?: IExtra): ITrackingProduct[] => {
  return [
    {
      id: builderId,
      offerType: 'Builder',
      position: 1,
      extra,
    },
  ];
};
